// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#cms-content{margin-top:72px!important}@media (min-width:1380px){#cms-content{margin-top:126px!important}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
